import AlertComponent from './containers/alertComponent'

export { default as AlertLayout } from './components/alertLayout' 

export default AlertComponent